/**
 * Extracts total hits from Elasticsearch response
 * Handles both old and new ES response formats
 */
export const getTotalHits = (response) => {
    if (!response?.hits?.total) {
        return 0;
    }
    // New format: { value: number }
    // Old format: number
    return response.hits.total?.value ?? response.hits.total ?? 0;
};

/**
 * Processes aggregation buckets into a key-value object
 */
const processAggregationBuckets = (buckets) => {
    const aggData = {};
    let sumAll = 0;
    
    buckets.forEach(bucket => {
        aggData[bucket.key] = bucket.doc_count;
        sumAll += bucket.doc_count;
    });
    
    return { aggData, sumAll };
};

/**
 * Processes aggregation data from Elasticsearch response
 * Returns aggregation data object with '__all__' key included
 */
export const processAggregations = (response, funnelStatus, totalAllHits) => {
    if (!response?.aggregations?.all_statuses?.funnel_status_agg) {
        return null;
    }
    
    const buckets = response.aggregations.all_statuses.funnel_status_agg.buckets || [];
    const { aggData, sumAll } = processAggregationBuckets(buckets);
    
    // Use sum of all buckets for "All" count, or actual total if showing all
    if (!funnelStatus || funnelStatus === '__all__') {
        const actualTotal = getTotalHits(response);
        aggData['__all__'] = actualTotal;
        return { aggData, totalAllHits: actualTotal };
    } else {
        // Use stored totalAllHits if available, otherwise sum of buckets
        aggData['__all__'] = totalAllHits || sumAll;
        return { aggData, totalAllHits };
    }
};

/**
 * Parses Elasticsearch response for websites list
 * Returns parsed data including websites, total hits, and aggregations
 */
export const parseWebsitesResponse = (response, funnelStatus, currentTotalAllHits) => {
    if (!response?.hits) {
        return {
            websites: [],
            totalHits: 0,
            aggregations: null,
            totalAllHits: currentTotalAllHits
        };
    }
    
    const websites = response.hits.hits || [];
    const totalHits = getTotalHits(response);
    const aggregationResult = processAggregations(response, funnelStatus, currentTotalAllHits);
    
    return {
        websites,
        totalHits,
        aggregations: aggregationResult?.aggData || null,
        totalAllHits: aggregationResult?.totalAllHits ?? currentTotalAllHits
    };
};

